import { SessionActorType } from "@bcasmart/doxecure-commons/doxecureTypes";

import { Dashboard } from "@containers/generics/Dashboard";
import { useAuthContext } from "@hooks/useAuthContext";
import { okOrError, optlog, defaultSectionInformations } from "@utils/functions";
import { BaseViewProps } from "@/utils/TypesAndConstants";

export const DraftView = (props: BaseViewProps) => {
    const { lockedAccount } = props;
    const { connectedProfileId } = useAuthContext();
    optlog(`+++ DraftView initialized with profile ID '${connectedProfileId}'`) ;

    return okOrError(
        connectedProfileId,
        (<Dashboard 
            title="Brouillons"
            emptyMessage="Pas de brouillons"
            category="draft"
            roles={[SessionActorType.Creator, SessionActorType.Expeditor]}
            lockedAccount={lockedAccount}
            sectionInfos={defaultSectionInformations} 
        />),
        false,
        "Impossible d'afficher la liste des brouillons car l'identifiant de profil de la personne connectée n'a pas pu être récupéré.",
        "Connexion invalide"
    ) ;
};
